import { ReactNode } from "react";
import styled from "styled-components";

export interface WideContainerProps {
  children: ReactNode;
}

export const WideContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-left: 4%;
  padding-right: 4%;

  ${(props) => props.theme.breakpoints.tabletUp} {
    padding-left: 2%;
    padding-right: 2%;
  }

  ${(props) => props.theme.breakpoints.xlDesktopUp} {
    padding-left: 0;
    padding-right: 0;
  }
`;
